import React, {FC} from 'react'
import {useIntl} from 'react-intl'

interface CompletedProps {
  email?: string
}

const Completed: FC<CompletedProps> = ({email}) => {
  const intl = useIntl()
  return (
    <div className='w-100'>
      <div className=''>
        <h2 className='fw-bolder d-flex align-items-center text-dark'>
          {intl.formatMessage({id: 'MENU.COMPLETED'})}
          <i
            className='fas fa-exclamation-circle ms-2 fs-7'
            data-bs-toggle='tooltip'
            title='Billing is issued based on your selected account type'
          ></i>
        </h2>
        <div className='text-gray-400 fw-bold fs-6'>
          {intl.formatMessage({id: 'MENU.EMAIL_SENT'}, {email: email})}
        </div>
      </div>
    </div>
  )
}

export default Completed
